module.exports = __webpack_public_path__ + "components/resort-condition/static/conditions-off-piste-a61ebc42d968c5595d0664b435d20def.svg";